export default "__VITE_ASSET__CmaD$0Jx__"